<template>
  <v-flex xl4 md7 sm9 xs13>
    <page-toolbar>
      <div ref="inputCurveNameDropDownList" style="width: 200px"></div>
      <div ref="yearDropDownList" style="width: 82px"></div>
      <div ref="monthDropDownList" style="width: 82px"></div>
      <div ref="evaluationDateDropDownList" style="width: 114px"></div>
      <kendo-button icon="excel" title="Export to Excel" @click="exportToExcel"> </kendo-button>
    </page-toolbar>
    <div v-if="loading">Loading...</div>
    <kendo-grid
      v-else
      height="calc(100vh - 165px)"
      :dataSource="gridDataSource"
      :toolbar="[]"
      ref="grid"
      :filterable="true"
      :sortable="true"
      :pageable-always-visible="false"
      :columns="columns"
    />
  </v-flex>
</template>
<script>
import PageToolbar from '@/components/PageToolbar'
import {mapGetters} from 'vuex'
const $ = kendo.jQuery
export default {
  mounted() {
    this.createToolbar()
  },
  components: {
    PageToolbar,
  },
  data() {
    return {
      loading: true,
      inputCurveId: -1,
      year: -1,
      month: -1,
      evaluationDate: null,
      inputCurveDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/PrimaryRate/getInputCurves',
            contentType: 'application/json',
            type: 'GET',
          },
        },
      }),
      yearDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/PrimaryRate/getEvaluationDateYears',
            contentType: 'application/json',
            data: () => ({inputCurveId: this.inputCurveId}),
            type: 'GET',
          },
        },
      }),
      monthDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/PrimaryRate/getEvaluationDateMonths',
            contentType: 'application/json',
            data: () => ({year: this.year, inputCurveId: this.inputCurveId}),
            type: 'GET',
          },
        },
      }),
      evaluationDateDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/PrimaryRate/getEvaluationDates',
            contentType: 'application/json',
            data: () => ({year: this.year, month: this.month, inputCurveId: this.inputCurveId}),
            type: 'GET',
          },
        },
      }),
      gridDataSource: new kendo.data.DataSource({
        transport: {
          read: {
            url: '/api/heroux/PrimaryRate',
            contentType: 'application/json',
            data: () => ({inputCurveId: this.inputCurveId, evaluationDateOa: this.evaluationDate}),
            type: 'GET',
          },
        },
        schema: {
          errors: 'errors',
          total: 'total',
          data: 'data',
          model: {
            id: 'dataInstrumentId',
            fields: {
              dataInstrumentId: {type: 'number'},
              instrumentCode: {type: 'string', editable: false},
              evaluationDate: {type: 'date', editable: false},
              instrumentValue: {type: 'number', Editable: false},
              tenor: {type: 'string', editable: false},
            },
          },
        },
      }),
      columns: [
        {
          field: 'dataInstrumentId',
          title: 'dataInstrumentId',
          hidden: true,
        },
        {
          field: 'instrumentCode',
          title: 'Instrument',
          width: 150,
        },
        {
          field: 'tenor',
          title: 'Tenor',
          width: 130,
        },
        {
          field: 'instrumentValue',
          title: 'Value',
          headerAttributes: {style: 'text-align: center;'},
          attributes: {style: 'text-align: right;'},
          format: '{0:n5}',
        },
      ],
    }
  },
  methods: {
    exportToExcel() {
      const url = `/api/heroux/PrimaryRate/exportToExcel?inputCurveId=${
        this.inputCurveId
      }&evaluationDateOa=${this.evaluationDate}&t=${this.tokenString}`
      location.href = url
    },
    async createInputCurveNameDropDown() {
      const vm = this
      return new Promise(function(resolve) {
        let inputCurveNameDropDown = $(vm.$refs.inputCurveNameDropDownList)
          .kendoDropDownList({
            dataTextField: 'inputCurveName',
            dataValueField: 'inputCurveId',
            dataSource: vm.inputCurveDataSource,
            dataBound: function() {
              this.select(0)
              vm.inputCurveId = this.value()
              this.trigger('change')
              resolve(inputCurveNameDropDown)
            },
            change: function() {
              vm.inputCurveId = this.value()
              vm.yearDataSource.read()
            },
          })
          .data('kendoDropDownList')
      })
    },
    async createYearDropDown() {
      const vm = this
      return new Promise(function(resolve) {
        let yearDropDown = $(vm.$refs.yearDropDownList)
          .kendoDropDownList({
            dataTextField: 'name',
            dataValueField: 'value',
            dataSource: vm.yearDataSource,
            dataBound: function() {
              this.select(0)
              vm.year = this.value()
              this.trigger('change')
              resolve(yearDropDown)
            },
            change: function() {
              vm.year = this.value()
              vm.monthDataSource.read()
            },
          })
          .data('kendoDropDownList')
      })
    },
    async createMonthDropDown() {
      const vm = this
      return new Promise(function(resolve) {
        let monthDropDown = $(vm.$refs.monthDropDownList)
          .kendoDropDownList({
            dataTextField: 'name',
            dataValueField: 'value',
            dataSource: vm.monthDataSource,
            dataBound: function() {
              this.select(0)
              vm.month = this.value()
              this.trigger('change')
              resolve(monthDropDown)
            },
            change: function() {
              vm.month = this.value()
              vm.evaluationDateDataSource.read()
            },
          })
          .data('kendoDropDownList')
      })
    },
    async createEvaluationDateDropDown() {
      const vm = this
      return new Promise(function(resolve) {
        let evaluationDateDropDown = $(vm.$refs.evaluationDateDropDownList)
          .kendoDropDownList({
            dataTextField: 'evaluationDateText',
            dataValueField: 'evaluationDateOa',
            dataSource: vm.evaluationDateDataSource,
            dataBound: function() {
              this.select(0)
              vm.evaluationDate = this.value()
              this.trigger('change')
              resolve(evaluationDateDropDown)
            },
            change: function() {
              vm.evaluationDate = this.value()
              vm.gridDataSource.read()
            },
          })
          .data('kendoDropDownList')
      })
    },
    async createToolbar() {
      await this.createInputCurveNameDropDown()
      await this.createYearDropDown()
      await this.createMonthDropDown()
      await this.createEvaluationDateDropDown()
      this.loading = false
    },
  },
  computed: {
    ...mapGetters({clientId: 'authentication/selectedClientId'}),
    ...mapGetters({role: 'authentication/currentRole'}),
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    editable() {
      return this.role != 'Guest'
    },
  },
}
</script>
